const getGps = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve(p.coords),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  });

const safeJson = (url) => fetch(url).then((r) => (r.ok ? r.json() : null)).catch(() => null);

async function reverseGeocode(lat, lon) {
  const d = await safeJson(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=16`);
  if (!d) return {};
  const a = d.address || {};
  return {
    city: a.city || a.town || a.village || a.suburb || a.county || null,
    region: a.state || null,
    country: a.country || null,
    address: d.display_name || null,
  };
}

export async function captureLocation() {
  const [coords, ipInfo] = await Promise.all([getGps(), safeJson("https://ipapi.co/json/")]);
  const net = { ip: ipInfo?.ip || null, isp: ipInfo?.org || null };
  if (coords) {
    const geo = await reverseGeocode(coords.latitude, coords.longitude);
    return {
      ...net,
      location: { source: "gps", lat: coords.latitude, lon: coords.longitude, accuracy: coords.accuracy, ...geo },
    };
  }
  if (ipInfo?.latitude) {
    return {
      ...net,
      location: {
        source: "ip", lat: ipInfo.latitude, lon: ipInfo.longitude, accuracy: null,
        city: ipInfo.city, region: ipInfo.region, country: ipInfo.country_name, address: null,
      },
    };
  }
  return { ...net, location: { source: "unavailable" } };
}
